import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["component", "isActive", "isHover", "isFocus", "isUsingKeyboard", "useBrowserDefaultFocusStyle"];
import React from 'react';
import { absoluteBorder, borderRadiusRounded, browserFocusReset, controlPaddingBlock, controlSizeFallback, cssBorderRadius, cssColorValue, cssControlSize, cssSpacing, durationMedium, focusBorderColor, focusBorderWidth, focusBottomBorder, opacityDisabled, overflowWrapFlexText, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var transitionColor = durationMedium;
var NavPillListItemLink = /*#__PURE__*/React.forwardRef(function NavPillListItemLink(_ref, ref) {
  var Component = _ref.component,
    isActive = _ref.isActive,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    isUsingKeyboard = _ref.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref.useBrowserDefaultFocusStyle,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
});
var activeStyles = css(["background-color:", ";color:", ";"], cssColorValue(semanticColors.backgroundTintedBase), cssColorValue(semanticColors.textBase));
var focusStyles = css(["", " ", " padding-block-end:0;&::after{color:", ";inline-size:calc(100% - ", ");}"], browserFocusReset, focusBottomBorder(focusBorderWidth, true, true), focusBorderColor, cssControlSize('smaller', '32px'));
var focusSelectedStyles = css(["position:relative;", " &::after{", " content:'';border-radius:", ";border:", "px solid ", ";}"], browserFocusReset, absoluteBorder(), borderRadiusRounded, focusBorderWidth, focusBorderColor);
var getFocusStyles = function getFocusStyles(_ref2) {
  var isActive = _ref2.isActive,
    isUsingKeyboard = _ref2.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref2.useBrowserDefaultFocusStyle;
  if (!isUsingKeyboard || useBrowserDefaultFocusStyle) return null;
  if (isActive) return focusSelectedStyles;
  return focusStyles;
};
var hoverStyles = css(["color:", ";"], cssColorValue(semanticColors.textBase));
var disabledStyles = css(["color:", ";cursor:not-allowed;pointer-events:none;opacity:", ";"], cssColorValue(semanticColors.textSubdued), opacityDisabled);

// eslint-disable-next-line prefer-arrow-callback
export var Link = styled(NavPillListItemLink).withConfig({
  displayName: "Link",
  componentId: "sc-nmmha9-0"
})(["", ";color:", ";border-radius:", ";display:flex;align-items:center;padding-block:", ";min-block-size:", ";padding-inline:", ";transition:", " color linear;text-decoration:none;", ";&:hover{", "}", " &[disabled],&[aria-disabled=\"true\"]{", "}", " &:not(:active){", "}&:active{", " ", "}", " &:focus{&:not(:active){", "}&:active{", "}}"], rootStyle(), cssColorValue(semanticColors.textSubdued), cssBorderRadius('larger-3', '16px'), cssSpacing('tighter-4', controlPaddingBlock.sm), cssControlSize('smaller', controlSizeFallback.small), cssSpacing('base', '16px'), transitionColor, overflowWrapFlexText(), hoverStyles, function (props) {
  return props.isHover && hoverStyles;
}, disabledStyles, function (props) {
  return props.isActive && css(["&,&:hover{", "}"], activeStyles);
}, function (_ref3) {
  var isFocus = _ref3.isFocus,
    isActive = _ref3.isActive,
    useBrowserDefaultFocusStyle = _ref3.useBrowserDefaultFocusStyle;
  return isFocus && !useBrowserDefaultFocusStyle && getFocusStyles({
    isActive: isActive,
    isUsingKeyboard: true,
    useBrowserDefaultFocusStyle: false
  });
}, activeStyles, function (_ref4) {
  var isFocus = _ref4.isFocus,
    useBrowserDefaultFocusStyle = _ref4.useBrowserDefaultFocusStyle;
  return isFocus && !useBrowserDefaultFocusStyle && getFocusStyles({
    isActive: true,
    isUsingKeyboard: true,
    useBrowserDefaultFocusStyle: false
  });
}, function (_ref5) {
  var useBrowserDefaultFocusStyle = _ref5.useBrowserDefaultFocusStyle;
  return !useBrowserDefaultFocusStyle && browserFocusReset;
}, function (_ref6) {
  var isActive = _ref6.isActive,
    isUsingKeyboard = _ref6.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref6.useBrowserDefaultFocusStyle;
  return getFocusStyles({
    isActive: isActive,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  });
}, function (_ref7) {
  var isUsingKeyboard = _ref7.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref7.useBrowserDefaultFocusStyle;
  return getFocusStyles({
    isActive: true,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle
  });
});